import styled from "styled-components";
import themes from "@/styles/themes";
import {mdiAlert, mdiClose} from "@mdi/js";
import Icon from "@mdi/react";
import {SET_MODAL, SET_USER_TAB} from "@/store/slices/appSlice";
import {useDispatch, useSelector} from "react-redux";
import { useEffect } from "react";
import { GET_OFFER_TYPE } from "@/store/slices/offerSlice";
import Events from "@/utils/Events";

const Block = styled.div`
  background: white;
  padding: 34px 38px;
  text-align: center;
  border-radius: 5px;
  box-shadow: 0 7px 40px 0 rgba(0, 0, 0, 0.06);
  border: solid 1px #d6d6d6;
  position: relative;
`
const ContentArea = styled.div`
  position: relative;
  width: 252px;
`
const IconDiv = styled.div`
  background: ${themes.yellow};
  color: ${themes.white};
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  margin: 6px 0;
`

const SubTitle = styled.div`
  font-size: 16px;
  margin: 6px 0;
`
const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${themes.grey};
  cursor: pointer;
  position: absolute;
  right: 12px;
  top: 12px;

  svg {
    width: 14px;
    height: 14px;
  }
`
const AnotherOfferButton = styled.a`
  background: ${themes.estadao};
  border: none;
  color: white;
  font-weight: 700;
  padding: 9px;
  cursor: pointer;
  display: inline-block;
  margin: 6px 0;
  width: 100%;
  border-radius: 5px;
`
const AnotherOfferButtonWhite = styled(AnotherOfferButton)`
background: white;
color: ${themes.estadao};
border: 1px solid ${themes.estadao};
`

interface IEmailJaCadastradoProps{
  data: string
}

export default function EmailJaCadastrado(props:IEmailJaCadastradoProps) {
    const dispatch = useDispatch();
    const email = props.data
    const offer_type = useSelector(GET_OFFER_TYPE)
    const events = new Events();

    useEffect(()=>{
      events.trigger("identificacao_cadastro_email_cadastrado", { offer_type })
    });

    function setTab(idx: number) {
      dispatch(SET_USER_TAB(idx))
      dispatch(SET_MODAL({type: null, show: false}))
    }

    return (
        <Block>
            <CloseButton onClick={() => {
                dispatch(SET_MODAL({type: null, show: false})), events.trigger("identificacao_cadastro_fechar_email_cadastrado", { offer_type })
            }}><Icon path={mdiClose} size={1}></Icon></CloseButton>

            <ContentArea>
                <IconDiv>
                    <Icon path={mdiAlert} size={1}/>
                </IconDiv>

                <SubTitle>
                 O e-mail <span style={{fontWeight:'bold'}}>{email}</span> <br/>
                  <span>já está cadastrado no Estadão</span>
                </SubTitle>
                <AnotherOfferButton onClick={() => setTab(1)}>
                    Ir para o login
                </AnotherOfferButton>
                <AnotherOfferButtonWhite onClick={() => setTab(0)}>
                    Cadastrar com outro e-mail
                </AnotherOfferButtonWhite>
            </ContentArea>
        </Block>
    )
}